import { gql } from '@apollo/client';

/** Every runner in a meeting's races, for the tips page's Field view (the race_field feature). */
export const GET_RACE_FIELD = gql`
  query GetRaceField($raceIds: [String!]!) {
    raceField(raceIds: $raceIds) {
      raceId
      number
      barrier
      horseName
      jockey
      trainer
      weight
      oddsOpening
      oddsCurrent
      detailedInfo {
        horse_age
        horse_sex
        horse_sire
        horse_dam
        horse_last10
        horse_record
        horse_record_distance
        horse_record_track
        horse_record_track_distance
        horse_record_firm
        horse_record_good
        horse_record_soft
        horse_record_heavy
        horse_record_first_up
        horse_record_second_up
        horse_prize_money
        horse_record_synthetic
      }
    }
  }
`;
